import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { StockConfigurationType } from 'app/typings/core/common/openingConfiguration/stockConfigurationType';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as INVENTORY_CORE_QUERY_KEYS } from '../inventory';

import { ENDPOINTS } from '.';

type PayloadProps = {
  experienceId: number;
  hotelId: number;
  closedDaysBeforeCheckIn?: number | null;
  openingConfiguration: {
    stockConfiguration: StockConfigurationType;
  };
};

export function useSaveExperienceConfiguration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PayloadProps) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateExperienceConfiguration,
          params: {
            id: payload.hotelId.toString(),
            experienceId: payload.experienceId.toString(),
          },
        },
        payload
      ) as Promise<void>,
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [
          INVENTORY_CORE_QUERY_KEYS.packScore,
          { hotelId: payload.hotelId },
        ],
      });
    },
    onError: (_, payload) => {
      message.error(
        `Error while modifying experience #${payload.experienceId}`
      );
    },
  });
}
